import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import TheCreativeVision from "./sections/TheCreativeVision";
import ServiceSpectrum from "./sections/ServiceSpectrum";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <TheCreativeVision />
      <ServiceSpectrum />
      <Footer />
    </div>;
}